module.exports = __webpack_public_path__ + "img/sunlei_2.373e2f7a.png";